export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;

  $(`#${widgetName}`).append('<div class="multiFeatureContent"><h1>upcoming events</h1></div>');
  setTimeout(function() {
  $(".all-events-btn").insertAfter('.multiFeatureContent');
  }, 5000);
  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath
    , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
    , detectIpad: IPADDETECTED
    // options
    , detectIpad: IPADDETECTED
    // options
    , allEventsLink: true
    , allEventsLinkText: 'VIEW Full Calendar'
    , hasImages: false
    , imageBackground: false
    , lazyLoadImages: true
    , buyNowButton: { visible: false, text: '>' }
    , moreButton: { visible: false, text: 'MORE' }
    , maxItemsVisible: 4
    , isResponsive: false
    , hasDescription: false
    , textContainer: true
    , link: 'all' //options are 'all', 'text', 'image', 'imageAndText', or ''
    , attributeOrder: {
      1: 'image',
      2: 'title',
      3: 'date',
      4: 'description',
      5: 'buttons'
    }
    , multiFeatureLoaded: function (data) {
      // console.log(data);
      // use function below if "more" text needs to appear at end of description text
      $('#multiScheduleFeature .featureItem').each(function () {
        // Create a new div element to wrap the featureItem
        var wrapperDiv = $('<div class="featureItemWrapper"></div>');
    
        // Reference to the current featureItem element
        var featureItem = $(this);
    
        // Find elements within the featureItem
        var itemDescripton = featureItem.find('.featureItemDescription');
        var itemtittle = featureItem.find('.featureItemTitle');
    
        // Limit character length of item title
        var characterLimitTitle = 40;
        var itemTitleText = itemtittle.text();
        if (itemTitleText.length > characterLimitTitle) {
            var trimmedTextTitle = itemTitleText.substring(0, characterLimitTitle);
            itemtittle.text(trimmedTextTitle);
        }
    
        // Limit character length of item description
        var characterLimitDescription = 120;
        var itemDescriptonText = itemDescripton.text();
        if (itemDescriptonText.length > characterLimitDescription) {
            var trimmedTextDescription = itemDescriptonText.substring(0, characterLimitDescription) + '...';
            itemDescripton.text(trimmedTextDescription);
        }
    
        // Append the featureItem content to the wrapperDiv
        wrapperDiv.append(featureItem.contents());
    
        // Replace the content of the featureItem with the wrapped content
        featureItem.html(wrapperDiv);
    });
    
      $()
    }
  });

};

